<!-- Status Configuration starts -->
<div class="container">
  <div class="row">
    <div class="col-12 mt-3">
      <div class="tab-title">Appointment Status</div>
      <form #myForm="ngForm">
        <div class="card mb15">
          <div class="card-header" translate>
            lblStatusKnowFromHere
          </div>
          <div class="card-content">
            <div class="card-body">
              <div class="row">
                <div class="col-12 col-md-6 col-lg-3">
                  <label for="template-edit-Page" translate>lblOurStatus</label>
                  <div class="form-group" *ngFor="let status of statusList; let i=index">
                    <div class="">
                      <ng-select [(ngModel)]="status.id" [ngModelOptions]="{standalone: true}" [disabled]="true">
                        <ng-option *ngFor="let status of statusList" [value]="status.id">{{status.name}}</ng-option>
                      </ng-select>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-9">
                  <div class="row">
                    <div class="col-md-12 col-lg-4">
                      <label for="template-edit-Page" translate>lblCustomerStatus</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-12" *ngFor="let status of statusList; let i=index;">
                      <div class="controls row align-items-center">
                        <div class="col-12 col-md-12 col-lg-4">
                          <input type="text" name="customer-status{{i}}" [disabled]="!userRoleRightsDetails.canEdit"
                            class="form-control" [(ngModel)]="mapData[i].DMSStatusLabel">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <ng-container *ngIf="userRoleRightsDetails.canEdit">
            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
              <button type="submit" class="btn btn-primary " aria-label="Center Align" (click)="saveStatus()" translate>lblSaveChanges</button>
            </div>
          </ng-container>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Status Configuration ends -->